const language = {
  label: 'Chọn ngôn ngữ',
};

export default language;
